import styled from 'styled-components'

export const LoadingBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 110000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, .75);
`

export const LoadingBackgroundImage = styled.img``
